import React from 'react';
import { Tooltip, Typography } from '@mui/material';

const NameTooltip = ({
  name = '',
  surname = '',
  children,
  fontSize = '14px',
  fontWeight = 400,
  typographySx = {},
  tooltipSx = {},
  placement = 'top',
}) => {
  const fullName = `${name || ''} ${surname || ''}`.trim();

  if (!fullName) {
    return children || null;
  }

  const defaultSx = {
    fontFamily: 'Poppins',
    fontWeight: 300,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: 0,
    maxWidth: '100%',
    cursor: 'pointer',
    ...typographySx,
  };

  const content = children ? (
    React.cloneElement(children, {
      sx: {
        ...defaultSx,
        ...(children.props?.sx || {}),
      },
    })
  ) : (
    <Typography sx={defaultSx}>{fullName}</Typography>
  );

  return (
    <Tooltip
      title={fullName}
      arrow
      placement={placement}
      enterDelay={200}
      leaveDelay={0}
      disableInteractive={false}
      disablePortal={false}
      PopperProps={{
        container: () => document.body,
        sx: {
          zIndex: 99999999,
        },
      }}
      slotProps={{
        tooltip: {
          sx: {
            fontFamily: 'Poppins',
            fontSize,
            fontWeight,
            whiteSpace: 'nowrap',
            maxWidth: 'none',
            padding: '6px 10px',
            ...tooltipSx,
          },
        },
      }}
    >
      {content}
    </Tooltip>
  );
};

export default NameTooltip;
